import { useState, useEffect, memo } from "react";
import img1 from "../../assets/Default_Height (1).webp";
import img2 from "../../assets/Default_Width (1).webp";
import { evaluate } from "mathjs";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

const MeasurementCalculator = ({ factor, calculationExpression, setMeasurement }) => {
  const productDetails = useSelector((state) => state.product.productDetails);

  const [width, setWidth] = useState(0); // Default width in inches
  const [widthFraction, setWidthFraction] = useState("0"); // Fraction for width
  const [height, setHeight] = useState(0); // Default height in inches
  const [heightFraction, setHeightFraction] = useState("0"); // Fraction for height
  const [sqft, setSqft] = useState(0); // Calculated square feet
  const [price, setPrice] = useState(0); // Calculated price

  const fractions = ["0", "1/4", "3/8", "1/2", "5/8", "3/4", "7/8"];

  const calculate = (newWidth, newHeight) => {
    try {
      // Define the variables for math.js
      const scope = {
        w: newWidth, 
        h: newHeight,
      };
      // Evaluate the expression using math.js
      const result = evaluate(calculationExpression, scope);
      const roundedSqft = Math.round(result);
      setSqft(roundedSqft);

      // Calculate price
      const calculatedPrice = roundedSqft * parseFloat(factor);
      setPrice(calculatedPrice);
      setMeasurement(Number(calculatedPrice));
    } catch (error) {
      Swal.fire("Something went wrong");
    }
  };

  useEffect(() => {
    if (productDetails) {
      setWidth(productDetails.minWidth);
      setHeight(productDetails.minHeight);
    }
  }, [productDetails]);

  useEffect(() => {
    if (width > 0 && height > 0) {
      calculate(width, height);
    }
  }, [width, height, calculationExpression]);

  if (!productDetails) {
    return <div>Loading...</div>;
  }

  const { minWidth, maxWidth, minHeight, maxHeight } = productDetails;

  return (
    <div className="p-6 bg-gray-50 rounded-lg shadow-lg">
      <h1 className="text-2xl font-bold text-center mb-6 text-gray-800">
        Enter Measurements
      </h1>
      <div className="flex flex-col md:flex-row justify-around items-center space-y-4 md:space-y-0">
        {/* Width Section */}
        <div className="flex flex-col  space-y-4">
          <h1>Width (in Inches)</h1>
          <img
            src={img2}
            alt="Width"
            className="w-40 h-40 object-contain border border-gray-300 rounded-md shadow-sm"
          />
                    <div className="flex items-start justify-betwen w-10 gap-2">

          <select
            className="border border-gray-300 rounded-md px-4 py-2 w-40 bg-white shadow-sm focus:ring-2 focus:ring-blue-500"
            value={width}
            onChange={(e) => setWidth(parseInt(e.target.value, 10))}
          >
            {Array.from({ length: maxWidth - minWidth + 1 }, (_, i) => i + minWidth).map((value) => (
              <option key={`width-${value}`} value={value}>
                {value}
              </option>
            ))}
          </select>
          <select
            className="border border-gray-300 rounded-md px-4 py-2 w-40 bg-white shadow-sm focus:ring-2 focus:ring-blue-500"
            value={widthFraction}
            onChange={(e) => setWidthFraction(e.target.value)}
          >
            {fractions.map((fraction) => (
              <option key={`width-fraction-${fraction}`} value={fraction}>
                {fraction}
              </option>
            ))}
          </select>
          </div>
        </div>

        {/* Height Section */}
        <div className="flex flex-col  space-y-4">
          <h1>Height (in Inches)</h1>
          <img
            src={img1}
            alt="Height"
            className="w-40 h-40 object-contain border border-gray-300 rounded-md shadow-sm" 
          />
                    <div className="flex items-start justify-betwen w-10 gap-2">
                    <select
            className="  border border-gray-300 rounded-md px-4 py-2 w-40 bg-white shadow-sm focus:ring-2 focus:ring-blue-500"
            value={height}
            onChange={(e) => setHeight(parseInt(e.target.value, 10))}
          >
            {Array.from({ length: maxHeight - minHeight + 1 }, (_, i) => i + minHeight).map((value) => (
              <option key={`height-${value}`} value={value}>
                {value}
              </option>
            ))}
          </select>
          <select
            className="w-40 border border-gray-300 rounded-md px-4 py-2  bg-white shadow-sm focus:ring-2 focus:ring-blue-500"
            value={heightFraction}
            onChange={(e) => setHeightFraction(e.target.value)}
          >
            {fractions.map((fraction) => (
              <option key={`height-fraction-${fraction}`} value={fraction}>
                {fraction}
              </option>
            ))}
          </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(MeasurementCalculator);